import { useNavigate, useLocation } from "react-router-dom";

export function useBackNavigationDialog() {
  const navigate = useNavigate();
  const location = useLocation();

  const openDialog = (id) => {
    const current = location.state?.dialogIds || [];
    if (!current.includes(id)) {
      navigate(location.pathname, {
        replace: false,
        state: { ...location.state, dialogIds: [...current, id] },
      });
    }
  };

  const closeDialog = (id) => {
    const current = location.state?.dialogIds || [];
    if (current.includes(id)) {
      const updated = current.filter((d) => d !== id);
      if (updated.length > 0) {
        // Still other dialogs open → just update state
        navigate(location.pathname, {
          replace: true,
          state: { ...(location.state || {}), dialogIds: updated },
        });
        navigate(-1);
      } else {
        // No dialogs left → go back in history
        navigate(-1);
      }
    }
  };

  return { openDialog, closeDialog, dialogLocation: location };
}
